import Vue from 'vue'
import VueRouter from 'vue-router'

import adminRoutes from '@/modules/admin/routes'
import adminOrganizationRoutes from '@/modules/adminOrganization/routes'
import authRoutes from '@/modules/auth/routes'
import homeRoutes from '@/modules/home/routes'
import lenderRoutes from '@/modules/lenders/routes'
import questionnaireRoutes from '@/modules/questionnaire/routes'
import resourceRoutes from '@/modules/resource/routes'
import userRoutes from '@/modules/user/routes'

import * as guards from './guards'

import store from '../stores'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    ...adminRoutes,
    ...adminOrganizationRoutes,
    ...authRoutes,
    ...homeRoutes,
    ...lenderRoutes,
    ...resourceRoutes,
    ...questionnaireRoutes,
    ...userRoutes,
    {
      path: '*',
      redirect: '/',
    },
  ],
  linkActiveClass: 'active',
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
})

router.beforeEach(guards.setPageTitle)
router.beforeEach(guards.resetScrolledStatus)

router.beforeEach(async (to, from, next) => {
  const feathers = store.state.feathers.client

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (await feathers.authentication.getAccessToken()) return next()
    else return next({ name: 'Home' })
  }

  if (!(await feathers.authentication.getAccessToken())) return next()

  if (!to.matched.some(({ meta }) => meta.requiresAuth || meta.accessAnyWhere)) {
    const { isQuizCompleted, dealId } = store.state.questionnaireStore

    const nextRoute = isQuizCompleted
      ? ({ name: 'Matches', params: { dealId } })
      : ({ name: 'LenderResults' })

    return next(nextRoute)
  }

  return next()
})

export default router
